import React from "react";
import {
  Box,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const loanHistoryList = this.props.loanHistoryList;
    const searchData = this.props.searchData;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <h3><center><u>Loan History Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
        <h4><center>{searchData.routeName === undefined ? 'All Routes' : 'Route - ' + searchData.routeName}</center></h4>
        <h4><center>{searchData.startDate} - {searchData.endDate}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ borderCollapse: 'collapse', width:'100%'}}>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                    <TableCell align={'center'} style={cellStyle}>Route Name</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Reg No</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Name</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Loan Amount (Rs)</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Installments</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Interest Rate</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Start Date</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loanHistoryList.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'center'} component="th" scope="row" style={{ border: '1px solid black', padding: '1px', fontSize: '0.9rem', textAlign: 'left' }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={{ border: '1px solid black', padding: '0.5px', fontSize: '0.9rem', textAlign: 'left'}}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={{ border: '1px solid black', padding: '1px', fontSize: '0.9rem', textAlign: 'right' }}>
                        {data.principalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                        {data.numberOfInstalments}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                        {data.annualRate}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                        {data.loanIssuedDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={{ border: '1px solid black', padding: '1px', fontSize: '0.9rem', textAlign: 'right',boxSizing: 'border-box'}}>
                        {data.isPaymentCompleated == true ? 'Completed' : 'Ongoing'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
